<section [class]="'mx-auto px-4 sm:px-6 lg:px-0 bg-faq mt-32 '+dir">

    <div class="lg:pt-24  pt-10">
        <h2 class="lg:text-4xl text-xl text-white text-center font-semibold ">{{"FAQ.FAQHEAD"|translate}}</h2>
        <p class="text-gray-400 text-center">{{"FAQ.FAQMSG"|translate}}</p>
    </div>
    <div class="relative ">
        <figure class="absolute z-0 hidden lg:block"><img src="../../../../assets/icon_question.png" alt="Questions">
        </figure>
        <figure class="absolute right-5  z-0 hidden lg:block"><img src="../../../../assets/icon_question_small.png"
                alt="Questions"></figure>
    </div>
    <section class="lg:container lg:mx-auto py-5 lg:px-8 2xl:px-52 relative z-10">

        <div class="mt-6 bg-white shadow-md  rounded-lg z-10">

            <p-accordion expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up">
                <p-accordionTab header="{{'FAQ.Q1'|translate}} " [selected]="true" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS1"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q2'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS2"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q3'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS3"|translate}}</p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q4'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS4"|translate}}</p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q5'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS5"|translate}}</p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q6'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS6"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q7'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS7"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q8'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS8"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q9'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS9"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q10'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS10"|translate}}
                    </p>
                </p-accordionTab>
                <p-accordionTab header="{{'FAQ.Q11'|translate}}" iconPos="end">
                    <p class="text-secondary-light p-5">{{"FAQ.ANS11"|translate}}
                    </p>
                </p-accordionTab>
            </p-accordion>

        </div>
    </section>
</section>